import React, { useEffect } from 'react';
import Header from '../../../headerone/Main';
import Bredcom from '../../../Bredcom/Main';
import VehicleRegistrationDetails from '../../subdepartmentdetails/VehicleRegistration';

function VehicleRegistration() {
  useEffect(() => {
    document.getElementById("title").innerHTML = "Vehicle Registration || Motor Vehicles";
  }, []);

  return (
    <>
      {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

      <div className="page-wrapper">
        <Bredcom 
          subtitle="Motor Vehicles"
          title="Vehicle Registration"
          subtitledown="Department of Motor Vehicles"
        />
        <VehicleRegistrationDetails />
      </div>
    </>
  );
}

export default VehicleRegistration;
